export default "__VITE_ASSET__BgwtJ$UX__"